import React from 'react';
import './App.css';

function Internships() {
  return (
    <main className="internships">
      <section className="section-head internship-head">
        <p className="eyebrow">Internships</p>
        <h2>Internship Opportunities and Practical Legal Training Under Experienced Professional Supervision</h2>
      </section>

      <section className="internship-copy">
        <div className="internship-copy-inner">
          <p>
            As an ongoing process we accept applications from law students and fresh law graduates who seek meaningful
            exposure to the practical working of the legal profession. We offer selected interns an opportunity to
            learn under the supervision of a senior legal practitioner with over 36 years of standing at the Bar,
            including practice before the Honourable Supreme Court of Pakistan.
          </p>
          <p>
            The internship is intended for individuals who are serious about building a career in law and wish to
            develop a sound understanding of litigation practice, legal drafting, case preparation, legal research,
            court procedure, and professional ethics. Interns are exposed to matters relating to civil,
            constitutional, corporate, family, banking, property, and Alternate Dispute Resolution. Please note that
            this is an unpaid internship, Law students and Fresh law graduates seeking practical legal training are
            encouraged to apply. The duration of the internship shall be determined by mutual understanding, keeping in
            view the availability of the applicant and the requirements of the Firm. Interested candidates may send
            their CV/Resume on{' '}
            <a href="mailto:irfanharoon@irfanharoonassociates.com">irfanharoon@irfanharoonassociates.com</a>,
          </p>
        </div>
      </section>
    </main>
  );
}

export default Internships;
